import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    Validators,
    FormControl,
} from '@angular/forms';
import { emailValidator } from 'src/app/shared/email-validator/email.validator';
import { FieldLength } from '../field-length';
import { LoginService } from '../login-service/login.service';
import { View } from '../view.enum';

@Component({
    selector: 'ols-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
    @Input() isShowingConfirmationBubble: boolean;
    @Output() viewChange: EventEmitter<View> = new EventEmitter();

    constructor(private fb: FormBuilder, private loginService: LoginService) {}

    public FieldLength = FieldLength;
    public form: FormGroup;

    public get emailCtrl(): FormControl {
        return this.form.get('email') as FormControl;
    }

    public get passwordCtrl(): FormControl {
        return this.form.get('password') as FormControl;
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            email: ['', [Validators.required, emailValidator]],
            password: ['', [Validators.required]],
        });
    }

    public submitForm() {
        if (this.form.valid) {
            this.loginService.logIn(
                this.emailCtrl.value,
                this.passwordCtrl.value
            );
        }
    }

    public openResetPassword() {
        this.viewChange.emit(View.RESET_PASSWORD);
    }

    public openSignUp() {
        this.viewChange.emit(View.SIGN_UP);
    }
}
